document.addEventListener('DOMContentLoaded', () => {
  function enableSoldOutOptions() {
    const inputs = document.querySelectorAll('.option-value-input');

    inputs.forEach((input) => {
      const wrapper = input.closest('[data-option-value-wrapper]');
      const isSoldOut = input.dataset.soldout === 'true';

      if (isSoldOut) {
        input.removeAttribute('disabled');
        input.disabled = false;

        if (wrapper) {
          wrapper.classList.add('option-value--soldout');
        }
      } else {
        if (wrapper) {
          wrapper.classList.remove('option-value--soldout');
        }
      }
    });
  }

  enableSoldOutOptions();

  document.addEventListener('change', () => {
    setTimeout(enableSoldOutOptions, 0);
    setTimeout(enableSoldOutOptions, 50);
    setTimeout(enableSoldOutOptions, 150);
  });

  const observer = new MutationObserver(() => {
    enableSoldOutOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled', 'data-soldout']
  });
});